import request from "@/utils/request";

/**
 * 帖子相关 API
 */

/**
 * 分页查询帖子
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页数量
 * @param {number} topicId 话题ID（可选）
 * @param {string} sort latest|hot
 * @returns {Promise}
 */
export function getPostPage(pageNum = 1, pageSize = 10, topicId, sort = "latest") {
  return request.get("/api/post/page", {
    params: {
      pageNum,
      pageSize,
      topicId,
      sort,
    },
  });
}

/**
 * 根据ID获取帖子详情
 * @param {number} id 帖子ID
 * @returns {Promise}
 */
export function getPostById(id) {
  return request.get(`/api/post/${id}`);
}

/**
 * 获取所有启用的话题
 * @returns {Promise}
 */
export function getTopicAll() {
  return request.get("/api/post/topic/all");
}

/**
 * 发布帖子
 * @param {Object} post 帖子数据
 * @returns {Promise}
 */
export function publishPost(post) {
  return request.post("/api/post/publish", post);
}

/**
 * 删除帖子
 * @param {number} id 帖子ID
 * @returns {Promise}
 */
export function deletePost(id) {
  return request.delete(`/api/post/${id}`);
}

/**
 * 当前用户帖子分页（个人中心，需登录）
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页数量
 * @param {string} status 状态：1 已发布 0 未发布
 * @returns {Promise}
 */
export function getPostPageCurrentUser(pageNum = 1, pageSize = 10, status) {
  return request.get("/api/post/page/currentUser", {
    params: {
      pageNum,
      pageSize,
      status,
    },
  });
}

/**
 * 指定用户已发布帖子分页（公开）
 * @param {number} userId 用户ID
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页数量
 * @returns {Promise}
 */
export function getPostPageByUserId(userId, pageNum = 1, pageSize = 10) {
  return request.get(`/api/post/page/user/${userId}`, {
    params: {
      pageNum,
      pageSize,
    },
  });
}
